import { render, staticRenderFns } from "./tabCustomerSocial.vue?vue&type=template&id=3447dff8&"
import script from "./tabCustomerSocial.vue?vue&type=script&lang=js&"
export * from "./tabCustomerSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports